module.exports = __webpack_public_path__ + "img/process-robot-placeholder.484cdb53.png";